import React from 'react';
import styles from './style.css';
import {Dummy} from '../';

export default class ElectroCell extends Dummy {

    render() {
        return (
            <div className={styles.electro} id={this.props.div_id}>
                <table className={styles.tg}>
                    <tbody>
                    <tr>
                        <th className={styles.subtitle}>U(B)</th>
                        <th className={styles.subtitle}>I(A)</th>
                    </tr>
                    <tr>
                        <th onClick={() => {
                            this.props.openModal(this.props.chartPs[0]);
                        }} className={styles.value}>{this.props.ps[0].value}</th>
                        <th onClick={() => {
                            this.props.openModal(this.props.chartPs[1]);
                        }} className={styles.value}>{this.props.ps[1].value}</th>
                    </tr>
                    <tr>
                        <th onClick={() => {
                            this.props.openModal(this.props.chartPs[0]);
                        }} className={styles.value}> {this.props.ps[2].value}</th>
                        <th onClick={() => {
                            this.props.openModal(this.props.chartPs[1]);
                        }} className={styles.value}> {this.props.ps[3].value}</th>
                    </tr>
                    <tr>
                        <th onClick={() => {
                            this.props.openModal(this.props.chartPs[0]);
                        }} className={styles.value}> {this.props.ps[4].value}</th>
                        <th onClick={() => {
                            this.props.openModal(this.props.chartPs[1]);
                        }} className={styles.value}> {this.props.ps[5].value}</th>
                    </tr>
                    </tbody>
                </table>
            </div>

        );
    }
}

ElectroCell.propTypes = {
    ps: React.PropTypes.array.isRequired,
    openModal: React.PropTypes.func,
    chartPs: React.PropTypes.array,
    div_id: React.PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/components/entries/ElectroCell/index.jsx